"use client";

import { Swiper } from "react-vant";
import Image from "next/image";
import { matomoSetCustomDimension } from '@/utils/matomoEvent';
import styles from "@/styles/home/banner-swiper.module.scss";

interface SwiperItem {
  title: string;
  link: string;
  imgUrl: string;
}

interface BannerSwiperProps {
  bannerData: SwiperItem[];
}
export default function BannerSwiper({ bannerData }: BannerSwiperProps) {
  const handleViewDetail = (image: SwiperItem) => {
    if (!image.link) return;
    window.location.href = image.link;
  };

  // 如果没有banner数据，不渲染组件
  if (!bannerData || bannerData.length === 0) {
    return null;
  }

  return (
    <div>
      <Swiper
        autoplay={4000}
        loop={false}
        indicatorProps={{ className: styles["banner-indicator"] }}
      >
        {bannerData.map((image: SwiperItem, index: number) => (
          <Swiper.Item key={image.link} onClick={() => handleViewDetail(image)}>
            <Image
              style={{ display: "block", width: "100%", height: "auto" }}
              src={image.imgUrl}
              alt={image.title}
              priority={index <= 1 ? true : false}
              fetchPriority={index === 0 ? "high" : "auto"}
              width={"375"}
              height={"157"}
              onClick={() => {
                matomoSetCustomDimension(2, image.title);
                matomoSetCustomDimension(3, index + 1);
              }}
            />
          </Swiper.Item>
        ))}
      </Swiper>
    </div>
  );
}
